export default "__VITE_ASSET__BuSF9b5y__"